// NEXUS by ELYSIUM — encrypted attribution: ELYSIUM::KAYE-WITEHIRA::OWNED
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import Layout from "./components/Layout";
import Landing from "./pages/Landing";
import Explore from "./pages/Explore";
import { Navigate } from "react-router-dom";
const NotFoundRedirect = () => <Navigate to="/" replace />;
import Watch from "./pages/Watch";
import Library from "./pages/Library";
import Wallet from "./pages/Wallet";
import OwnerHQ from "./pages/OwnerHQ";
import CreatorHQ from "./pages/CreatorHQ";
import SponsorHQ from "./pages/SponsorHQ";
import Auth from "./pages/Auth";
import Pricing from "./pages/Pricing";
import Coins from "./pages/Coins";
import Studio from "./pages/Studio";
import Quests from "./pages/Quests";
import StaffConsole from "./pages/StaffConsole";
import Verify from "./pages/Verify";
import Profile from "./pages/Profile";
import StudioTools from "./pages/StudioTools";
import TipShortlink from "./pages/TipShortlink";
import Messenger from "./pages/Messenger";
import VerticalFeed from "./pages/VerticalFeed";
import ParentalControls from "./pages/ParentalControls";
import Marketplace from "./pages/Marketplace";
import { DMInbox, DMThread } from "./pages/Messages";
import MeRedirect from "./pages/MeRedirect";
import BReelsStudio from "./pages/BReelsStudio";
import Groups from "./pages/Groups";
import Group from "./pages/Group";
import BusinessSuite from "./pages/BusinessSuite";
import Settings from "./pages/Settings";
import Legal from "./pages/Legal";
import Friends from "./pages/Friends";
import IncomingCallOverlay from "./components/IncomingCallOverlay";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Layout>
            <IncomingCallOverlay />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/explore" element={<Explore />} />
              <Route path="/realms/:slug" element={<NotFoundRedirect />} />
              <Route path="/watch/:id" element={<Watch />} />
              <Route path="/library" element={<Library />} />
              <Route path="/wallet" element={<Wallet />} />
              <Route path="/coins" element={<Coins />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/studio" element={<Studio />} />
              <Route path="/quests" element={<Quests />} />
              <Route path="/staff" element={<StaffConsole />} />
              <Route path="/verify" element={<Verify />} />
              <Route path="/u/:userId" element={<Profile />} />
              <Route path="/me" element={<MeRedirect />} />
              <Route path="/breels" element={<BReelsStudio />} />
              <Route path="/business" element={<BusinessSuite />} />
              <Route path="/studio/tools" element={<StudioTools />} />
              <Route path="/t/:handle" element={<TipShortlink />} />
              <Route path="/owner" element={<OwnerHQ />} />
              <Route path="/creator" element={<CreatorHQ />} />
              <Route path="/sponsor" element={<SponsorHQ />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/messages" element={<Messenger />} />
              <Route path="/messages/:convId" element={<Messenger />} />
              <Route path="/feed" element={<VerticalFeed />} />
              <Route path="/parental" element={<ParentalControls />} />
              <Route path="/marketplace" element={<Marketplace />} />
              <Route path="/dm" element={<DMInbox />} />
              <Route path="/dm/:id" element={<DMThread />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/groups" element={<Groups />} />
              <Route path="/group/:gid" element={<Group />} />
              <Route path="/legal" element={<Legal />} />
              <Route path="/legal/:doc" element={<Legal />} />
              <Route path="/friends" element={<Friends />} />
            </Routes>
          </Layout>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
